import { useEffect, useState } from "react";
import { Outlet, useMatch } from "react-router-dom";
import ComponentHeadline from "../../utillityComponents/ComponentHeadline";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

export default function SponsorsHome() {
  const matchEvent = useMatch('/sponsors/:event_slug')
  const matchDetail = useMatch('/sponsors/:event_slug/:sponsor_id')
  const event_slug = matchEvent?.params?.event_slug || matchDetail?.params?.event_slug

  const [eventName, setEventName] = useState(null)
  const axiosPrivat = useAxiosPrivate()

  useEffect(() => {
    if (!event_slug) {
      setEventName(null)
      return
    }
    axiosPrivat.get(`/event/get/${event_slug}`)
      .then((res) => setEventName(res.data.name))
      .catch(() => setEventName(null))
    // eslint-disable-next-line
  }, [event_slug])

  const title = eventName ? `Sponsorer — ${eventName}` : 'Sponsorer'

  return (
    <>
      <ComponentHeadline icon="HeartIcon" pagetitle={title} />
      <div className="px-4 sm:px-6 lg:max-w-6xl lg:mx-auto lg:px-0">
        <Outlet />
      </div>
    </>
  )
}
